import { render, staticRenderFns } from "./ChannelsPage.vue?vue&type=template&id=c52bd30c&scoped=true&"
import script from "./ChannelsPage.vue?vue&type=script&lang=js&"
export * from "./ChannelsPage.vue?vue&type=script&lang=js&"
import style0 from "./ChannelsPage.vue?vue&type=style&index=0&id=c52bd30c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52bd30c",
  null
  
)

export default component.exports